import React from 'react';
import type { ManufacturerSearchResult } from 'core/types';
import HKSelect from 'components/hk-select/HKSelect';

export interface ProductBrandStepFieldProps {
  /** Class prefix shared by the field, e.g. 'hk-digital-catalog-details'. */
  classPrefix: string;
  value: number | null;
  manufacturers: ManufacturerSearchResult[];
  onChange: (value: number | null) => void;
}

/**
 * Brand/Manufacturer catalog-select field, shared by DigitalCatalogDetails.tsx's
 * two question variants and InventoryAddProduct.tsx's Add Item flow — all
 * three previously carried byte-identical copies of this field and its
 * "picking a Brand clears an already-picked Model" precedence rule.
 */
const ProductBrandStepField: React.FC<ProductBrandStepFieldProps> = ({
  classPrefix,
  value,
  manufacturers,
  onChange
}) => {
  return (
    <HKSelect
      className={`${classPrefix}-catalog-select`}
      value={value}
      placeholder="Type the Brand (Optional)"
      options={manufacturers.map((manufacturer) => ({
        value: manufacturer.id,
        label: manufacturer.name
      }))}
      onChange={(newValue) => onChange(newValue as number | null)}
    />
  );
};

export default ProductBrandStepField;
